<template>
  <div class="localStoreInfo">
      <Qrcode-Dialog :show.sync="show" :qrCode="qrCode" :payParams="payParams" @refreshPoint='refreshPoint' />
      <div class="title">{{$t('other.a2166')}}</div>
      <div class="content">
          <p class="desc">{{$t('other.a2167')}}：</p>
      </div>

      <div >
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">{{$t('other.a2168')}}</el-menu-item>
            <el-menu-item index="2">{{$t('other.a2169')}} </el-menu-item>
            <el-menu-item index="3">{{$t('other.a2170')}}</el-menu-item>
          </el-menu>
      </div>
      <div style="display:flex;">
        <div class="recharge-item" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)" v-for="(item, index) in list" :key="index">
            <div class="thresr shopee" v-if="item.platform == 1"></div>
            <div class="thresr lazada" v-if="item.platform == 2"></div>
            <div class="thresr tiktok" v-if="item.platform == 3"></div>
            <div id="_san_248" style="text-align: center;">
                <span class="commodity-type">{{item.price}}</span><span id="_san_256">{{$t('other.a157')}}</span>
            </div>
            <div id="_san_260" class="commodity-buy-btn">
                <p  class="center-button-base center-button-yellow center-button-container-middle" @click="createPayorder(item)">{{$t('other.a1071')}}</p>
            </div>
            <div class="textDesc">
                <p>{{$t('other.a2171')}}：</p>
                <p>{{item.desc}}</p>
            </div>
        </div>
           
           
      </div>

  </div>
</template>

<script>
import api from '../../../api/moudles/deduction'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
data(){
return{
    activeIndex:'1',
    list:[],
    //1人独享店铺
    rechartList:[
    //     {
    //     price:1999,
    //     desc:this.$t('other.a2172'),
    //     platform:1,
    // },
    {
        price:1999,
        desc:this.$t('other.a2172'),
        platform:2,
    },{
        price:2999,
        desc:this.$t('other.a2172'),
        platform:3,
    },],
    //5人独享店铺
    fivelist:[
    //     {
    //     price:4999,
    //     desc:this.$t('other.a2172'),
    //     platform:1,
    // },
    {
        price:5999,
        desc:this.$t('other.a2172'),
        platform:3,
    },],

    //个人独享企业店铺
    enterprice:[{
        price:19999,
        desc:this.$t('other.a2172'),
        platform:2,
    },],
    payOptions:[],
    show:false,
    payParams:{},
    
    
}
},
computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				qrCode: state=>state.recharge.qrCode,
				isChecked: state=>state.recharge.isChecked,
				integral:state=>state.recharge.integral,
				actualIntegral:state=>state.recharge.actualIntegral,
				expectIntegral:state=>state.recharge.expectIntegral,
				usableIntegral:state=>state.recharge.usableIntegral,
				
				
			}),
		
		},
components: {
  QrcodeDialog:() => import(`../../../components/dialog/qrcodeDialog.vue`),
   

},
created(){
    this.list=this.rechartList
    this.getRechargeRules()
},
methods:{
    ...mapActions('recharge', [
        'createPayorderBywechat',
        'OrderTracking',
        'pointChange',
        'getSellerPoint'
    
    ]),
    refreshPoint(){
				this.getSellerPoint({
					userId:this.userId
				})

			},
    //创建支付订单
    createPayorder(item){
        console.log(item);
        let ttp=this.payOptions.find(p => p.payFee == item.price)
        
        let  params={
            rechargeId:ttp.rechargeId,
            userId:this.userId
        }
        
        this.payParams={
            userId:this.userId,
            rechargeId:ttp.rechargeId,
            price:ttp.payFee
        }
        
        this.createPayorderBywechat(params)
        this.show=true
    },
    handleSelect(key){
        console.log(key);
        this.list=key == 1 ? this.rechartList : key == 2 ? this.fivelist :this.enterprice
    },
    changeActive($event){
        $event.currentTarget.className="recharge-item ttp"
    },
    removeActive($event){
        $event.currentTarget.className="recharge-item"
    },
    getRechargeRules(){
        api
        .getUserRechargeRule()
        .then(res => {
            if(res.code === 200) {
                if(res.data){
                    console.log('收款规则',res.data)
                    let list=[1999,2999,4999,5999,19999]
                    this.payOptions=res.data.filter(p => {
                        if(list.indexOf(p.payFee) > -1){
                            return p
                        }
                    })

                    console.log('payOptions',this.payOptions);
                }
                
            }
        })
    },
}
}

</script>
<style lang="scss" scoped>
.localStoreInfo{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;

    /deep/ .el-menu-item{
        font-size: 18px;
        font-weight: 600;
    }

    .ttp{
		transform: scale(1.08);
	}

    .title{
        font-size: 25px;
        font-weight: 600;
        margin-bottom: 30px;
    }

    .tips{
        margin: 10px 0;
        font-weight: bold;
        
        
    }
    .desc{
        width:100%;
        font-size: 16px;
        color: rgba(0,0,0,.9);
    }

    .content{
        padding-left: 100px;
        margin-bottom: 30px;
        font-size: 16px;
        color: rgba(0,0,0,.9);
    }
    


    .recharge-item{
				width: 352px;
				height: 190px;
				box-shadow: rgba(0,0,0,.1) 0 0 25px;
				margin: 19px ;
				transition: all 0.5s;
				cursor: pointer;

                .thresr{
                    width: 100px;
                    height: 50px;
                    margin-left: 5px;
                    position: absolute;
                    
                    
                }

                .shopee{
                    background-image: url('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0271dc95d8de4b4c810aeb48d4e8a083.png');
                    background-position: 50% 8%;
                    background-size: 100%;
                    background-repeat: no-repeat;
                }

                .lazada{
                    background-image: url('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0271dc95d8de4b4c810aeb48d4e8a083.png');
                    background-position: 50% 18%;
                    background-size: 100%;
                    background-repeat: no-repeat;
                }

                .tiktok{
                    background-image: url('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0271dc95d8de4b4c810aeb48d4e8a083.png');
                    background-position: 50% 92%;
                    background-size: 100%;
                    background-repeat: no-repeat;
                }

                
               

                .textDesc{
                    font-size: 10px;
                    margin-top:20px;
                    padding-left: 21px;
                }


				.commodity-type{
					display: inline-block;
					font-size: 36px;
					color: #ca963b;
					margin-top: 50px;
					text-align: center;
				}

				.commodity-buy-btn{
					text-align: center;
				}

				.center-button-container-middle {
					width: 120px;
					height: 30px;
					font-size: 14px;
					line-height: 30px;
					text-align: center;
					border-radius: 15px;
				}
				
				.center-button-yellow {
					border: 1px solid #ca963b;
					color: #ca963b;
				}
				.center-button-base {
					cursor: pointer;
					display: inline-block;
					*display: inline;
					margin: 0 5px;
					*zoom: 1;
				}

				
			}


}
</style>